import React from 'react'

import AIValueLoop from './AIValueLoop'
import EnterpriseAIEntryPaths from './EnterpriseAIEntryPaths'
import EnterpriseAIFinalCTA from './EnterpriseAIFinalCTA'
import EnterpriseAIHero from './EnterpriseAIHero'
import EnterpriseAILogoStrip from './EnterpriseAILogoStrip'
import EnterpriseAIMetrics from './EnterpriseAIMetrics'
import EnterpriseAIUseCases from './EnterpriseAIUseCases'
import EnterpriseAIValuePillars from './EnterpriseAIValuePillars'
import ForwardDeployedEngineers from './ForwardDeployedEngineers'

const EnterpriseAIPage = ({ lang }) => (
  <div className="enterprise-ai-page">
    <EnterpriseAIHero lang={lang} />
    <EnterpriseAILogoStrip lang={lang} />
    <EnterpriseAIValuePillars lang={lang} />
    <AIValueLoop lang={lang} />
    <EnterpriseAIEntryPaths lang={lang} />
    <ForwardDeployedEngineers lang={lang} />
    <EnterpriseAIMetrics lang={lang} />
    <EnterpriseAIUseCases lang={lang} />
    <EnterpriseAIFinalCTA lang={lang} />
  </div>
)

export default EnterpriseAIPage
